// extracted by mini-css-extract-plugin
export default {"container":"Error-module__container--hvuBU"};